type PersonProps = {
  firstName: string;
  infix?: string | null | undefined;
  lastName: string;
};

export const getFullNameWithInfix = (props: PersonProps) => {
  return `${props.firstName}${props.infix ? ` ${props.infix}` : ''} ${props.lastName}`;
};
